import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { OrderLine } from 'src/app/modules/order/models/order-line';
import { faCaretUp, faCaretDown } from '@fortawesome/free-solid-svg-icons';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-shop-order-line',
  templateUrl: './shop-order-line.component.html',
  styleUrls: ['./shop-order-line.component.css']
})
export class ShopOrderLineComponent implements OnInit {

  faCaretUp = faCaretUp;
  faCaretDown = faCaretDown;

  @Input()
  orderLine: OrderLine;

  @Input()
  canRemoveLine: boolean;

  @Output()
  removeLine = new EventEmitter<OrderLine>();

  constructor() { }

  ngOnInit(): void {
  }

  get name(): string {
    return this.orderLine?.name;
  }

  get description(): string {
    return this.orderLine?.product?.description;
  }

  get count(): number {
    return this.orderLine?.quantity;
  }

  get price(): number {
    return this.orderLine.price;
  }

  get imgUrl(): string {
    return this.orderLine?.product?.getProductImageUrl() || '/web/static/src/img/placeholder.png';
  }

  toMoneyStr(x: number): string {
    return environment.globalSettings.toMoneyStr(x);
  }

  get canCountUp(): boolean {
    return this.count < 10;
  }

  get canCountDown(): boolean {
    return this.count > 1;
  }

  onClickCountChangeByOne(isUp: boolean): void {
    if (this.orderLine && (isUp && this.canCountUp || !isUp && this.canCountDown)) {
      this.orderLine.quantity += isUp ? 1 : -1;
    }
  }

  onRemoveLineClick(): void {
    this.removeLine.emit(this.orderLine);
  }
}
